module.exports = __webpack_public_path__ + "media/images/young_pin_design_award-2a2905e965b57512e47fb1455cb06da6.png";